import { render, staticRenderFns } from "./add-video-dialog.vue?vue&type=template&id=09a791a6&scoped=true&"
import script from "./add-video-dialog.vue?vue&type=script&lang=js&"
export * from "./add-video-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-video-dialog.vue?vue&type=style&index=0&id=09a791a6&scoped=true&lang=css&"
import style1 from "./add-video-dialog.vue?vue&type=style&index=1&id=09a791a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a791a6",
  null
  
)

export default component.exports